NtechApp.ResumeTipsForm = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._summarySelect = null;
    this._targetsSelect = null;
    this._highlightsSelect = null;
    this._interestsSelect = null;

    this._summaryMobileSelect = null;
    this._targetsMobileSelect = null;
    this._highlightsMobileSelect = null;
    this._interestsMobileSelect = null;

    this._selects = [];
    this._mobileSelects = [];

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        me._summarySelect = NtechApp.formManager.getFormSelectById("summaryCat");
        me._targetsSelect = NtechApp.formManager.getFormSelectById("targetCat");
        me._highlightsSelect = NtechApp.formManager.getFormSelectById("highlightCat");
        me._interestsSelect = NtechApp.formManager.getFormSelectById("interestCat");

        me._summaryMobileSelect = NtechApp.formManager.getFormSelectById("summaryTip");
        me._targetsMobileSelect = NtechApp.formManager.getFormSelectById("targetTip");
        me._highlightsMobileSelect = NtechApp.formManager.getFormSelectById("highlightTip");
        me._interestsMobileSelect = NtechApp.formManager.getFormSelectById("interestTip");

        me._selects = [me._summarySelect, me._targetsSelect, me._highlightsSelect, me._interestsSelect];
        me._mobileSelects = [
            me._summaryMobileSelect, me._targetsMobileSelect,
            me._highlightsMobileSelect, me._interestsMobileSelect
        ];

        me._updateAllSelectInputLabels();
        me._updateAllSelectTips();

        me._decreaseMobileSelectFontSize();
        me._restrictMobileSelectLabelUpdates();
        me._bindAllTipCategoriesToMobileSelects();
        me._updateAllMobileSelectTips();

        me._bindEvents();
    }

    this._bindEvents = function() {
        for(var i = 0; i < me._selects.length; i++) {
            me._bindSelectEvents(me._selects[i]);
        }
        for(var i = 0; i < me._mobileSelects.length; i++) {
            me._bindMobileSelectEvents(me._mobileSelects[i]);
        }

        me._click.listen(me._$view, "[data-tipId]", function(e) {
            var $tip = $(e.target).closest("[data-tipId]");
            me._insertTip($tip.closest("[data-textareaWithTips]"), $tip.find(".right").text());
        });
    }

    this._bindSelectEvents = function(select) {
        $(select).on(NtechApp.SelectForm.EVENT_OPTION_SELECT, function(e, text, val) {
            me._updateAllSelectTips();
            me._updateAllMobileSelectTips();
            me._updateSelectInputLabel(select);
        });
    }

    this._bindMobileSelectEvents = function(mobileSelect) {
        $(mobileSelect).on(NtechApp.SelectForm.EVENT_OPTION_SELECT, function(e, text, val) {
            var $textareaWithTips = mobileSelect.getSelectInput().closest("[data-textareaWithTips]");
            me._insertTip($textareaWithTips, text);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.ResumeTipsForm, {
    _updateAllSelectTips: function() {
        for(var i = 0; i < this._selects.length; i++) {
            var $textareaWithTips = this._selects[i].getSelectInput().closest("[data-textareaWithTips]");
            var selectedVal = this._selects[i].getVal();

            var $tips = $textareaWithTips.find("[data-tipId]");
            $tips.css("display", "none");
            $textareaWithTips.find("[data-tipCategory='" + selectedVal + "']").css("display", "block");
        }
    },

    _updateAllSelectInputLabels: function() {
        for(var i = 0; i < this._selects.length; i++) {
            var $selectInput = this._selects[i].getSelectInput();
            $selectInput.val("Tip section: " + $selectInput.val());
        }
    },

    _updateSelectInputLabel: function(select) {
        var $selectInput = select.getSelectInput();
        $selectInput.val("Tip section: " + $selectInput.val());
    },

    _restrictMobileSelectLabelUpdates: function() {
        for(var i = 0; i < this._mobileSelects.length; i++) {
            this._mobileSelects[i].restrictLabelUpdates();
        }
    },

    _decreaseMobileSelectFontSize: function() {
        for(var i = 0; i < this._mobileSelects.length; i++) {
            this._mobileSelects[i].getForm().addClass("smallOptionText");
        }
    },

    _insertTip: function($tipWrapper, tipText) {
        var text = $.trim(tipText);
        var $textarea = $tipWrapper.find("textarea");

        var cursorPos = $textarea.prop('selectionStart');
        var v = $textarea.val();
        var textBefore = v.substring(0,  cursorPos);
        var textAfter  = v.substring(cursorPos, v.length);

        $textarea.val(textBefore + text + textAfter);
    },

    _bindAllTipCategoriesToMobileSelects: function() {
        for(var i = 0; i < this._selects.length; i++) {
            var $textareaWithTips = this._selects[i].getSelectInput().closest("[data-textareaWithTips]");
            var $mobileSelectForm = this._mobileSelects[i].getForm();

            $.each($textareaWithTips.find("[data-tipId]"), function() {
                var tipId = $(this).attr("data-tipId");
                var tipCategoryId = $(this).attr("data-tipCategory");

                $mobileSelectForm.find("[data-optionValue='" + tipId + "']").attr("data-tipCategory", tipCategoryId);
            });
        }
    },

    _updateAllMobileSelectTips: function() {
        for(var i = 0; i < this._mobileSelects.length; i++) {
            var $selectForm = this._mobileSelects[i].getForm();
            var selectedVal = this._selects[i].getVal();

            var $tipOptions = $selectForm.find("[data-tipCategory]");
            $tipOptions.css("display", "none");
            $selectForm.find("[data-tipCategory='" + selectedVal + "']").css("display", "block");
        }
    }
});